import { useQuery } from '~/services'

export const useIsAdkBot = ({ workspaceId, botId }: { workspaceId: string; botId: string }): boolean => {
  const { data: bot, isLoading } = useQuery('workspaces_/$workspaceId_/bots_/$botId_', {
    workspaceId,
    botId,
  })

  if (isLoading || !bot) {
    return false
  }

  return bot.tags?.runtime === 'adk'
}
